/**
 * Chat History Item Component
 * Displays a single chat session in the history list
 */

import React from 'react';

import { useSessionManagerContext } from '../../sessionManagement/SessionManagerContext';
import type { ChatHistoryItem } from '../../types/apiTypes';
import {
  HistoryItemContainer,
  HistoryItemContent,
  HistoryItemLabel,
} from './ChatHistoryItem.styled';
import LineClamp from './LineClamp';

export type ChatHistoryItemProps = {
    item: ChatHistoryItem;
};

const ChatHistoryItemComponent: React.FC<ChatHistoryItemProps> = ({ item }) => {
  const sessionManager = useSessionManagerContext();
  const isSelected = sessionManager.currentSessionId === item.ChatSessionId;

  return (
      <HistoryItemContainer
          type="button"
          onClick={() => sessionManager.loadSession(item.ChatSessionId)}
          aria-label="Load this chat"
          data-qa-id="load-chat-history-item"
          $isActive={isSelected}
      >
          <HistoryItemContent>
              <LineClamp
                  className="chat-history-item-label"
                  qa-id="item-label"
                  clampLines={1}
                  showTitle={true}
              >
                  <HistoryItemLabel $isActive={isSelected}>
                      {item.Label ?? 'New chat'}
                  </HistoryItemLabel>
              </LineClamp>
          </HistoryItemContent>
      </HistoryItemContainer>
  );
};

export default React.memo(ChatHistoryItemComponent);
